import React, { useState } from 'react';
import { connect } from 'react-redux';
import '../components.scss';
import { Button, Form } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { Multiselect } from 'multiselect-react-dropdown';
import { postLead } from '../../redux/reduxActions/leadActions';
import {
  setLeadData, setObjectiveSelector, setSelectors, validateRequiredFields,
} from '../utils';
import { faBorderNone } from '@fortawesome/free-solid-svg-icons';


const AddNewLead = (props) => {
  const [subject, setSubject] = useState('');
  const [funnelTypeState, setFunnelType] = useState('');
  const [funnelStatus, setFunnelStatus] = useState('');
  const [priority, setPriority] = useState(4);
  const [responsibleState, setResponsible] = useState('');
  const [workTypeState, setWorkType] = useState('');
  const [workTechState, setWorkTech] = useState('');
  const [comment, setComment] = useState('');
  const [disableBtn, setDisableBtn] = useState(false);
  const addLead = () => {
    validateRequiredFields(funnelTypeState, funnelStatus, priority, responsibleState);
    if (!funnelTypeState || !funnelStatus || !priority || !responsibleState) {
      return;
    }
    setDisableBtn(true);
	  let workTypes;
    let workTech;
    if (workTypeState) {
	    workTypes = workTypeState.map((item) => item.id);
    } else {
	    workTypes = [];
    }
    if (workTechState) {
	    workTech = workTechState.map((item) => item.id);
    } else {
	    workTech = [];
    }
    props.postLead(
      setLeadData(
        subject,
        funnelTypeState,
        funnelStatus,
        priority,
        responsibleState,
	      workTypes,
	      workTech,
        comment,
      ),
	    props.history.push,
    );
  };
  const {
    priorities, funnelStatuses, funnelType, workType, workTech, responsible,
  } = props;

  return (
    <div>
      <div className="lead__container" style={{boxShadow: '0 0 10px #ced4da',border: '1px solid #ced4da'}}>
        <h3 style={{ color: '#383838', marginBottom: 10 }}>Create new Lead</h3>
        <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
          <p className="lead__title">
						Subject
          </p>
          <TextareaAutosize
            maxLength={101}
            onChange={({ target }) => setSubject(target.value)}
            className="lead__textarea lead__input"
            rows={1}
            placeholder="..."
          />
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Funnel Type
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target }) => setFunnelType(target.value)}>
              <option key="" value="">none</option>
              {setSelectors(funnelType)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Funnel Status
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target }) => setFunnelStatus(target.value)}>
              <option key="" value="">none</option>
              {setSelectors(funnelStatuses)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Priority
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control
              as="select"
              value={priority}
              onChange={({ target }) => setPriority(target.value)}
            >
              <option key="" value="">none</option>
              {setObjectiveSelector(priorities)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Responsible
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control as="select" onChange={({ target }) => setResponsible(target.value)}>
              <option key="" value="">none</option>
              {setObjectiveSelector(responsible)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
						Work Type
          </p>
          <div
            style={{ width: '50%' }}
          >
            <Multiselect
              options={workType}
              onSelect={(event) => {
							  setWorkType(event);
              }}
              onRemove={(event) => {
	              setWorkType(event);
              }}
              displayValue="name"
            />
          </div>
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
						Work Tech
          </p>
          <div
            style={{ width: '50%' }}
          >
            <Multiselect
              options={workTech}
              onSelect={(event) => {
							  setWorkTech(event);
              }}
              onRemove={(event) => {
	              setWorkTech(event);
              }}
              displayValue="name"
            />
          </div>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">Description</p>
          <TextareaAutosize
            className="lead__textarea"
            style={{ width: '80%', padding: 10 }}
            rows={3}
            placeholder="..."
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => addLead()}
            variant="primary"
            style={{ marginTop: 20 }}
            className="main-button-filled"
            disabled={disableBtn}
          >
					Add New Lead
          </Button>
        </div>
      </div>
    </div>
  );
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  funnelStatuses: state.leadReducer.funnelStatuses,
  funnelType: state.leadReducer.funnelType,
  workType: state.leadReducer.workType,
  workTech: state.leadReducer.workTech,
  responsible: state.leadReducer.responsible,
}), { postLead })(AddNewLead);
